import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import HeaderLeft from "./HeaderLeft";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";

function ConfirmYourIdentity(props) {
  const initialValues = {
    number: "",
  };
  const validationSchema = Yup.object({
    number: Yup.string().required("required"),
  });
  const onSubmit = async (values) => {
    console.log("cell number", values);
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, handleChange, handleBlur, handleSubmit }) => (
        <Fragment>
          <header>
            <div class="custom_container ">
              <HeaderLeft />
              <div class="user_profile"></div>
            </div>
          </header>
          <section class="otp_verification custom_hight">
            <div class="login_inner">
              <h1 class="mb_30 main_title ">Confirm your identity</h1>
              <p class="mb_40 them_para text-center mx-auto">
                Enter your cell number... Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt{" "}
              </p>
              <form
                onSubmit={handleSubmit}
                action="index_submit"
                method="get"
                acceptCharset="utf-8"
              >
                <div class="form-group">
                  <input
                    name="number"
                    onChange={handleChange("number")}
                    onBlur={handleBlur("number")}
                    value={values.number}
                    type="text"
                    class="custom_input "
                    placeholder="Cell Number"
                  />{" "}
                  <ErrorMessage name="number" />
                </div>
                <div class="btn_wraper">
                  {/*  <button type="submit" class="them_btn mt_40 mb_30">
                    Verify
                  </button> */}
                  <Link to="/otpVerificationNumber">
                    <button type="submit" class="them_btn mt_40 mb_30">
                      Verify
                    </button>
                  </Link>
                </div>
              </form>
            </div>
          </section>
        </Fragment>
      )}
    </Formik>
  );
}

export default ConfirmYourIdentity;
